//import Badge from "components/shared/badge";
import { useCurrentEtudeData } from "components/EtudeForm/hooks/useCurrentEtudeData";
import Badge from "components/shared/badge";
import { FC } from "react";
import { useAppliedFilterValue } from "./useAppliedFilterValue";
import { useFilterConfig } from "./useFilterConfig";
import useTranslation from "utils/hooks/useTranslation";

export const AppliedFilters: FC<{}> = () => {
  const { t } = useTranslation();

  const {
    activeSolutions: solutions,
    installationType,
    solutionRequestBody: appliedSolutionFilter,
    hasEcs,
    hasChauffage,
    service,
    hasTcoupure,
  } = useCurrentEtudeData();

  const { defaultValues, traitement_anti_corrosion } = useAppliedFilterValue({
    appliedSolutionFilter,
    appointPuissanceTotale: solutions?.[0]?.appoint?.puissance_totale,
  });

  const filterConfig = useFilterConfig({
    appliedSolutionFilter,
    type: installationType,
    preference_pac: defaultValues.preference_pac,
    code_gamme_pac: (defaultValues.code_gamme_pac ?? []) as string[],
    traitement_anti_corrosion,
    hasEcs,
    hasChauffage,
    service,
    hasTcoupure,
    appointPuissanceTotale: solutions?.[0]?.appoint?.puissance_totale,
    currentSolutions: solutions,
  });

  return (
    <group
      data-space-horizontal="5"
      data-gap="5"
      data-direction="column"
      data-wrap="no"
      data-length="380"
      className="appliedFilters"
    >
      <group data-sticky="top" data-background="main-background">
        <Badge
          data-length="autofit"
          outline
          weight={700}
          data-text-size="medium"
          data-height="30"
          text={`${t("FO_SOL_NUMBER_SOLUTION")} = ${solutions?.length}`}
        />
      </group>
      {filterConfig
        .filter((conf) => conf.displayCondition)
        .map((fc) => {
          const value = defaultValues?.[fc.name as keyof typeof defaultValues];
          const isArray = Array.isArray(value);
          if (
            [null, undefined, ""].includes(value as any) ||
            (isArray && (value.length as number) == 0)
          ) {
            return null;
          }

          let displayValue = isArray ? (
            <>
              {value.map((v) => (
                <Badge
                  key={v}
                  outline
                  filled
                  data-height="30"
                  data-text-line="1.3"
                  text={t(
                    fc.options?.find((o) => o.value == v)?.label ??
                    (v as string)
                  )}
                />
              ))}
            </>
          ) : (
            <Badge
              outline
              filled
              data-height="30"
              data-text-line="1.3"
              text={`${t(
                fc.options?.find((o) => o.value == value)?.label ??
                ((value as string) || "")
              )}${fc.unit ? ` ${t(fc.unit)}` : ""} `}
            />
          );

          return (
            <group data-gap="5" key={fc.name}>
              <Badge
                outline
                data-height="30"
                data-text-line="1.3"
                text={`${t(fc.title)} :`}
              />
              {displayValue}
            </group>
          );
        })}
    </group>
  );
};
